// Active status = the automated base rate is already applied.
// Inactive status = the automated base rate is not yet applied.
export enum BRAStatusEnum {
  Active = "Active",
  Inactive = "Inactive",
}
